import React from 'react';
import TierGrid from '../TierGrid';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { useTiers } from '../../_hocs/withTiers';
import { useCurrentTier } from '../../_hocs/withCurrentTier';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import TierCardForExplorer from './TierCardForExplorer';

export interface Props {}

const TierExplorer: React.FC<Props> = () => {
  const { tiers, isTierStreamInitialized, isFetchingTiers, hasMoreTiers, fetchMoreTiers } =
    useTiers();
  const { setCurrentTierId } = useCurrentTier();

  const onTierClick = tier => {
    setCurrentTierId(tier.deviationId);
  };

  const renderTier = ({ index, width }) => {
    const tier = tiers[index];

    return <TierCardForExplorer width={width} deviation={tier} onClick={onTierClick} />;
  };

  const fetchMoreTiersIfNeeded = () => {
    if (!hasMoreTiers || isFetchingTiers) {
      return;
    }
    fetchMoreTiers();
  };

  const renderContent = () => {
    return (
      <>
        {isTierStreamInitialized && (
          <TierGrid
            cookieType={MeasuredCookieType.GALLECTION_EXPLORER}
            tiers={tiers}
            tierRenderer={renderTier}
          />
        )}
        {isFetchingTiers && <LoadingIndicator view="daSymbol" coverMode={!tiers.length} />}
      </>
    );
  };

  return (
    <PopupInnerLayout
      scrollableContent={renderContent()}
      onScrolledToBottom={fetchMoreTiersIfNeeded}
      onNotScrollable={fetchMoreTiersIfNeeded}
    />
  );
};
TierExplorer.displayName = 'TierExplorer';

export default TierExplorer;
